import { z } from "zod";

import { createEmailSchema } from "@/shared/lib/validation/user-schemas";

export const LOGIN_ERROR_MESSAGE =
  "아이디(이메일) 또는 비밀번호를 다시 입력해 주세요.\n아이디와 비밀번호를 정확히 입력해 주세요.";

export const loginFormSchema = z.object({
  email: createEmailSchema((key) => key).refine(() => true, { message: LOGIN_ERROR_MESSAGE }),
  password: z.string().min(1, LOGIN_ERROR_MESSAGE).max(50, LOGIN_ERROR_MESSAGE),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
